import {
  Col,
  Container,
  Card,
  CardBody,
  Row,
  FormGroup,
  Label,
  Button,
  Table,
  Form,
} from "reactstrap";
import { Btn, P } from "../../AbstractElements";
import { Income, CreatePinTital, Epin, SendMultiplePin } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState, useRef } from "react";
import { decryptData } from "../../utils/helper/Crypto";
import { format } from "date-fns";
import { useCommonService } from "../../Service/CommonService/Commonservice";
import { IoSearchSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import "./Searchpin.scss";
import { useSweetAlert } from "../../Context/SweetAlertContext";

// Define Pin option type
type PinOption = {
  id: number;
  name: string;
  total: number;
};

// Define Row type
type RowData = {
  id: number;
 // ProductId: number;
  pinType: string;

  total: number;
  quantity: number;
};
const SendMultiplePinReport = () => {
  const { ApiCalling, ExecuteProcedure, ProductJsontable } = useCommonService();
  const { showAlert, ShowSuccessAlert, ShowConfirmAlert } = useSweetAlert();


  const navigator = useNavigate();
  ///-------------------------------------search report part-----------------------------------------------

  const [memberID, setmemberID] = useState(
    decryptData(localStorage.getItem("clientId") as string)
  );
  const [getUserData, setgetUserData] = useState<any[]>([]);
  const [UserName, setUserName] = useState("");
  const GetUserDetails = async () => {
    const param = {
      UserName: UserName,
      ActionMode: "Select",
    };
    const obj = {
      procName: "GetMemberDetailsByUserName",
      Para: JSON.stringify(param),
    };
    const result = await ExecuteProcedure(obj);
    if (Array.isArray(result)) {
      setgetUserData(result);
    } else {
      setgetUserData([]);
    }
  };

  // this is your function
  // useEffect(() => {
  //   // attach to window so inline onclick can see it
  //   (window as any).handleAction = (type: string) => {
  //     if (type === "LevelIncome") {
  //       console.log("Go to LevelIncomeReport");
  //       navigator(`${import.meta.env.BASE_URL}/` + type);
  //     } else if (type === "RewardIncome") {
  //       navigator(`${import.meta.env.BASE_URL}/` + type);
  //       console.log("Go to RewardIncomeReport");
  //     }
  //   };
  // }, []);

  // ✅ Unified Data Fetcher

  const [pinPackages, setPinPackages] = useState<any[]>([]);

  // Fetch pin packages (similar to BindPinPackage)
  const GetPinPackages = async () => {
    const param = {
      ActionMode: "getallPinPackage",
      MemberId: memberID, // <-- ये आपका existing function है
    };

    const obj = {
      procName: "GetMemberDetailsByUserName",
      Para: JSON.stringify(param),
    };

    const result = await ExecuteProcedure(obj);
    if (Array.isArray(result)) {
      setPinPackages(result);
    } else {
      setPinPackages([]);
    }
  };
  useEffect(() => {
    GetPinPackages();
  }, []);
  // // Example pin types with total quantity
  // const pinOptions: PinOption[] = [
  //   { id: 1, name: "Gold Pin", total: 100 },
  //   { id: 2, name: "Silver Pin", total: 200 },
  //   { id: 3, name: "Platinum Pin", total: 300 },
  // ];

  const [rows, setRows] = useState<RowData[]>([]);
  const [selectedPin, setSelectedPin] = useState<string>("");
  const [totalQty, setTotalQty] = useState<number>(0);
  const [qty, setQty] = useState<number | "">("");
  // Add Row
  const handleAdd = () => {
    if (!selectedPin || !qty) {
      alert("Please select a pin type and enter quantity.");
      return;
    }
debugger
    const pkg = pinPackages.find((p) => p.PackageId === parseInt(selectedPin));
    if (!pkg) return;

    if (qty > pkg.TotalQuantity) return; // Validation

    const newRow: RowData = {
      id:parseInt(selectedPin),// rows.length + 1,
      //ProductId: parseInt(selectedPin), // ✅ store ID for backend
      pinType: pkg.PackageName.trim(),
      total: pkg.TotalQuantity,
      quantity: qty,
    };

    setRows([...rows, newRow]);
    setSelectedPin("");
    setTotalQty(0);
    setQty(""); // ✅ clear input instead of setting 0
  };
  const TransferPin = async() => {
    const confirmed = await ShowConfirmAlert("Pin Transfer ", "Are you sure want to transfer");
    if (confirmed) {
      try {
        console.log(rows);
const arr2 = rows.map(item => ({
  ProductName:item.pinType,
  ProductId: item.id,
  ProductQuantity:item.quantity,
  TotalQuantity:item.total   // column change
}));
        const para = {
          UserName: UserName,
          FromMemberId: memberID,
          ActionMode: 'Insert'
        }
        const JsonData = JSON.stringify(arr2)
        const procName = 'ProductJsonTable';

        const param={
          procName:procName,
          Para:JSON.stringify(para) ,
          JsonData:JsonData
        }
       //const param= "{ procName: '" + procName + "',Para:'" + JSON.stringify(para) + "',JsonData:'" + JsonData + "' }"
        const res = await ProductJsontable(param)
        debugger
        if (Array.isArray(res)) {
            if (res[0]?.StatusCode == "1") {
               setRows([]);
              ShowSuccessAlert(res[0]?.Msg);
              navigator(`${import.meta.env.BASE_URL}/PinTransferSuccesspage?FromMemberId=`+res[0]?.FromMemberId+`&ToMemberId=` +(res[0].ToMemberId) + `&PINCount=` + (res[0].PINCount) + `&PinTransferDate=` + (res[0].PinTransferDate))
            }
          };
        }
      catch{
        console.log('do nothing.');
      }
      } 
      else {
      console.log('do nothing.');
    }

  }
  
  // Handle Select Change
  const handlePinChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSelectedPin(selectedValue);

    const pkg = pinPackages.find(
      (p) => p.PackageId === parseInt(selectedValue)
    );
    setTotalQty(pkg ? pkg.TotalQuantity : ""); // ✅ keep number, not string
  };

  // Delete Row
  const handleDelete = (id: number) => {
    if (window.confirm("Are you sure you want to delete this row?")) {
      setRows((prev) => prev.filter((row) => row.id !== id));
    }
  };
  // Calculate SubTotal
  const subTotal = rows.reduce((sum, row) => sum + row.quantity, 0);
  return (
    <>
      <style>{`
        .my-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
        }

        .my-table th,
        .my-table td {
          white-space: nowrap;
          padding: 8px 12px;
          text-align: center;
          min-width: 100px;
              font-size: 12px;
        }
        .my-table td#pintype {
          min-width: 200px;
        }

        .my-table th {
          font-weight: 600;
          border-bottom: 1px solid #ddd;
        }

        .my-table td {
          border-bottom: 1px solid #f0f0f0;
        }
      `}</style>
      <div className="page-body">
        <Breadcrumbs
          mainTitle={SendMultiplePin}
          parent={Epin}
          ChildName={SendMultiplePin}
        />
        <Container fluid className="innerPageCard">
          <Row className="align-items-center justify-content-between mb-3 p-3 bg-white rounded">
            <div className="col-md-3">
              <P className="mb-3">Member User Name</P>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <input
                  onChange={(e) => setUserName(e.target.value)}
                  className="form-control"
                  autoComplete="off"
                  type="text"
                  placeholder="Search by UserName"
                  name="Value"
                />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <button
                type="button"
                className="btn mb-3 btn-primary"
                onClick={GetUserDetails}
              >
                <IoSearchSharp /> Search
              </button>
            </div>
          </Row>

          <Col className="mb-3">
            <Card>
              <CardBody>
                <div className="container mt-4">
                  {/* Personal Details */}
                  {getUserData[0]?.StatusCode == '1' ? <><h5 className="mb-3">Personal Details</h5>
                    <Form>
                      <Row>
                        <Col md="4">
                          <FormGroup>
                            <Label className="">Name</Label>
                            <input
                              value={
                                getUserData.length ? getUserData[0].FirstName : ""
                              }
                              className="form-control"
                              autoComplete="off"
                              type="text"
                              placeholder="First Name"
                              name="FirstName"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="4">
                          <FormGroup>
                            <Label className="">PlaceUnder</Label>
                            <input
                              value={
                                getUserData.length
                                  ? getUserData[0].PlaceUnderId
                                  : ""
                              }
                              className="form-control"
                              autoComplete="off"
                              type="text"
                              placeholder="Place Under Id"
                              name="PlaceUnderId"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label>Sponsor </Label>
                            <input
                              value={
                                getUserData.length ? getUserData[0].SponsorId : ""
                              }
                              className="form-control"
                              autoComplete="off"
                              type="text"
                              placeholder="Sponsor Id"
                              name="SponsorId"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <Label>Counrty</Label>
                          <FormGroup>
                            <input
                              value={
                                getUserData.length ? getUserData[0].Country : ""
                              }
                              className="form-control"
                              autoComplete="off"
                              type="text"
                              placeholder="Country"
                              name="Country"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label>State </Label>
                            <input
                              value={
                                getUserData.length ? getUserData[0].State : ""
                              }
                              className="form-control"
                              autoComplete="off"
                              type="text"
                              placeholder="State"
                              name="State"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label>City </Label>
                            <input
                              value={
                                getUserData.length ? getUserData[0].City : ""
                              }
                              className="form-control"
                              autoComplete="off"
                              type="text"
                              placeholder="City"
                              name="City"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>


                    <hr />


                    <h5 className="mb-3">Pin Details</h5>
                    <div className="table-responsive">
                      <Table
                        bordered
                        hover
                        className="align-middle text-center table-auto my-table"
                      >
                        <thead className="table-dark">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Pin Type</th>
                            <th>Total Quantity</th>
                            <th>Quantity</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {/* Added Rows */}
                          {rows.map((row) => (
                            <tr key={row.id}>
                              <td>{row.id}</td>
                              <td id="pintype">{row.pinType}</td>
                              <td>{row.total}</td>
                              <td>{row.quantity}</td>
                              <td>
                                <Button
                                  color="danger"
                                  style={{ padding: "4px 9px", fontSize: "12px" }}
                                  onClick={() => handleDelete(row.id)}
                                >
                                  <RxCross2 />
                                </Button>
                              </td>
                            </tr>
                          ))}

                          {/* Input Row */}
                          <tr>
                            <td>#</td>
                            <td id="pintype">
                              <select
                                value={selectedPin}
                                className="form-select mb-2"
                                onChange={handlePinChange}
                              >
                                {pinPackages.map((pkg) => (
                                  <option
                                    key={pkg.PackageId}
                                    value={pkg.PackageId}
                                    data-totalquantity={pkg.TotalQuantity}
                                  >
                                    {pkg.PackageName.trim()}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <input
                                type="text"
                                value={totalQty}
                                placeholder="Total Qty"
                                className="form-control mb-2"
                                disabled
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={qty === "" ? "" : qty} // agar blank ho to empty string dikhayega
                                className="form-control mb-2"
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setQty(val === "" ? "" : parseInt(val, 10)); // blank ko "" rakho
                                }}
                                placeholder="Enter Qty"
                                max={totalQty || undefined}
                              />

                              {qty !== "" && qty > (totalQty || 0) && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                  You cannot enter more than {totalQty}
                                </span>
                              )}
                            </td>
                            <td>
                              <Button
                                color="primary"
                                size="sm"
                                className="mb-2"
                                onClick={handleAdd}
                                disabled={!qty || qty > totalQty} // ✅ disable properly
                              >
                                Add
                              </Button>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>

                    <div className="d-flex justify-content-end mt-2">
                      <h5>
                        SubTotal: <span className="text-success">{subTotal}</span>
                      </h5>
                    </div>

                    <Button type="button" color="primary" onClick={TransferPin}>
                      Transfer
                    </Button>
                  </> : <div style={{ color: 'red' }}>{getUserData[0]?.Msg ? getUserData[0]?.Msg : ''}</div>}  </div>
              </CardBody>
            </Card>
          </Col>
        </Container>
      </div>
    </>
  );

};

export default SendMultiplePinReport;
